module.exports = __webpack_public_path__ + "img/page-3_img04.062d11b3.jpg";